import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { DatePicker, Form } from 'antd'
import { get } from 'lodash-es'
import moment from 'moment'
import PropTypes from 'prop-types'

const FormDatePicker = ({ name, label, ...rest }) => {
  const { control, errors } = useFormContext()
  const { message: errorMessage } = get(errors, name, {})

  return (
    <Form.Item
      label={label}
      help={errorMessage}
      validateStatus={errorMessage ? 'error' : 'success'}
    >
      <Controller
        control={control}
        name={name}
        render={({ onChange, value }) => (
          <DatePicker
            {...rest}
            value={value ? moment(value) : null}
            onChange={onChange}
          />
        )}
      />
    </Form.Item>
  )
}

FormDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
}

FormDatePicker.defaultProps = {
  label: '',
}

export default FormDatePicker
